import { useAdminStore } from "@voix/store/adminStore";
import { useVoixToast } from "@voix/composables/useVoixToast";
import { useSiteUtils } from "@voix/composables/useSiteUtils";
import { useCookie, useRuntimeConfig } from "#imports";
export default async function $voixFetch(request, options = {}) {
  const config = useRuntimeConfig();
  const { getCurrentDomain } = useSiteUtils();
  const domain = getCurrentDomain();
  const headers = {
    "X-VOIX-SITE": domain,
    "accept": "application/json"
  };
  const adminStore = useAdminStore();
  const releasePreviewHeader = adminStore.releaseId;
  if (releasePreviewHeader)
    headers["X-VOIX-RELEASE-PREVIEW"] = releasePreviewHeader;
  const accessToken = useCookie("auth-access-token");
  if (accessToken.value && (request.includes("api/admin") || options?.sendAuthHeader === true))
    headers.authorization = `Bearer ${accessToken.value}`;
  const theRequest = await $fetch(
    `${config.public.voixApiBaseUrl}${request}`,
    {
      ...options,
      headers: {
        ...headers,
        ...options?.headers
      }
    }
  );
  const errorValue = theRequest.error;
  if (errorValue) {
    const voixToast = useVoixToast();
    if (errorValue.data) {
      switch (errorValue.data.statusCode) {
        case 401:
          console.warn("Voix Nuxt API: Route to login");
          break;
        case 422:
          if (errorValue.data.data?.errors) {
            Object.keys(errorValue.data.data?.errors).forEach((key) => {
              errorValue.data.data?.errors[key].forEach((validationError) => {
                voixToast.add(validationError, "error");
              });
            });
          } else {
            voixToast.add(errorValue.data.message, "error");
          }
          break;
        default:
          console.error("Voix Nuxt API:", theRequest.error);
          voixToast.add(errorValue.data.message, "error");
          break;
      }
    } else {
      console.error("Voix Nuxt API:", errorValue);
    }
  }
  return theRequest;
}
